import React from "react";
import {Form, Message, Modal, Table} from "semantic-ui-react";
import userStore from "../stores/userStore";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {checkEdit, checkRole} from "../helper/rolehelper";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";

const DEFAULT_ERROR = "Werte dürfen nicht 0, oder leer sein.";
const TYPE_ERROR = "Falsche Angabe : Art der Tanklieferung";
const LOCATION_ERROR = "Falsche Angabe : Ort wurde nicht angegeben oder Wert ist falsch";

@observer
export default class PropanRow extends React.Component {

    @observable
    editPropan = {
        propanType: 1,
        date: new Date(),
        amountliter: 0,
        calorificvalue: 0,
        amountkWh: 0,
        costs: 0,
        proof: "",
        locationId: 0,
        id: 0,
        comment: ""
    };
    @observable
    error = false;

    @observable
    isEditModal = false;

    @observable
    addpropanModalOpen = false;

    @observable
    deleteModalOpen = false;

    @observable
    errorMessage = DEFAULT_ERROR;

    @observable privilegedUser = false;

    @observable edit = false;

    componentDidMount() {
    }


    constructor(props) {
        super(props);

        let user = userStore.userRolesFromServer;
        if (checkRole(user, "/propan")) {
            this.privilegedUser = true;
        } else {
            this.privilegedUser = user.toString().includes("admin");
        }
        this.edit = checkEdit(user, "/propan");

        this.state = {
            open: false,
            deleteopen: false,
            delete: true,
            edit: true
        }
    }


    //functions for edit
    checkInputValues() {
        console.log(this.editPropan);
        //Check if vehicle has Propan and check if amounts are right
        if (this.editPropan.length !== 0) {

            //Check if editHeatingoil has a valid type (1, 2 or 3)
            let type = (this.editPropan.propanType);
            if (type !== 1) {
                this.error = true;
                console.log(this.error);
                this.errorMessage = TYPE_ERROR;
                return;
            }

            //Check if location-Id has a valid type (not null, empty or undefined (valid = 1 - 7))
            let locationId = this.editPropan.locationId;
            console.log(locationId);
            if (locationId === null || locationId === '' || locationId === undefined) {
                this.error = true;
                this.errorMessage = LOCATION_ERROR;
                return;
            }

            let amountliter = this.editPropan.amountliter;
            let costs = this.editPropan.costs;
            let proof = this.editPropan.proof;
            if (amountliter === "" || costs === "" || amountliter === 0 || costs === "" || costs === 0 || proof === "") {
                this.error = true;
                this.errorMessage = DEFAULT_ERROR;
                console.log("value error");
                console.log(this.error);
                return;
            }
            this.setEdit();
        } else {
            this.error = true;
            console.log(this.error);
        }
    }

    setEdit() {
        console.log(this.editPropan.date);

        this.props.editPropan(this.editPropan, (this.editPropan.propanType));

        this.closeInput()
    }


    openEditPropanModal() {
        this.editPropan.propanType = this.props.propan.propanType;
        this.editPropan.date = new Date(this.props.propan.date * 1000);
        this.editPropan.amountliter = this.props.propan.amountliter;
        this.editPropan.calorificvalue = this.props.propan.calorificvalue;
        this.editPropan.amountkWh = this.props.propan.amountkWh;
        this.editPropan.costs = this.props.propan.costs;
        this.editPropan.proof = this.props.propan.proof;
        this.editPropan.comment = this.props.propan.comment;
        this.editPropan.locationId = this.props.locationId;
        this.editPropan.id = this.props.propan.id;
    }

    handleChange(date) {
        if (date === null) {
            this.setState({
                ...this.state,
                error: true
            })
        } else {
            this.editPropan.date = date;
        }
    }


    closeInput() {

        this.isEditModal = false;
        this.addpropanModalOpen = false;
        this.state.open = false;
        this.deleteModalOpen = false;
        this.editPropan = {
            propanType: this.props.propan.propanType,
            date: new Date(this.props.propan.date * 1000),
            amountliter: this.props.propan.amountliter,
            calorificvalue: this.props.propan.calorificvalue,
            amountkWh: this.props.propan.amountkWh,
            costs: this.props.propan.costs,
            proof: this.props.propan.proof,
            locationId: this.props.locationId,
            comment: this.props.propan.comment,
            id: this.props.propan.id
        };

        this.error = false;
    }


    handleInputChange(type, event, data) {
        this.editPropan.calorificvalue = 12.87;

        this.editPropan.amountkWh = this.editPropan.amountliter * this.editPropan.calorificvalue;
        if (type === 'propanType') {
            this.editPropan.propanType = data.value;
        } else if (type === 'date') {
            this.editPropan.date = data.value;
        } else if (type === 'costs') {
            if (data.value === "") {
                this.editPropan.costs = 0;
            } else
                this.editPropan.costs = data.value;
        } else if (type === 'amountliter') {
            if (data.value === "") {
                this.editPropan.amountliter = 0;
            } else {
                this.editPropan.amountliter = data.value;
            }
        } else if (type === 'proof') {
            this.editPropan.proof = data.value;
        } else if (type === 'comment') {
            this.editPropan.comment = data.value;
        }
        this.editPropan.locationId = this.props.locationId;
    }

    //functions for edit


    //functions for delete


    openDeletePropanModal(propansId) {
        this.deleteModalOpen = true;
        console.log(this.props.propan)
        this.props.deletePropan(propansId);
        this.closeDeleteInput();
    }


    closeDeleteInput() {
        this.addpropanModalOpen = false;
        this.isEditModal = false;
        this.state.deleteopen = false;
        this.deleteModalOpen = false;
        this.editPropan = {
            propanType: 1,
            date: new Date(),
            amountliter: "",
            calorificvalue: "",
            amountkWh: "",
            costs: "",
            proof: "",
            comment: ""
        };
        console.log(this.state.deleteopen);
        this.error = false;
    }

    //functions for delete


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    render() {
        const IdOptions = [
            {key: 4, text: 'Tanklieferung', value: 1},
            {key: 5, text: 'Tankkarte', value: 2},
            {key: 6, text: 'Fremdtankung', value: 3}
        ];
        const calorificvalue = 12.87;

        return (

            <Table.Row className="color-sub-row">
                <Table.Cell/>
                {this.edit ?
                    <Table.Cell>
                        <Modal open={this.state.deleteopen} className={"modal-top"}
                               onClose={this.closeDeleteInput.bind(this)} centered={false}
                               trigger={this.delete ?
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                                   :
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                               }>
                            <Modal.Header>Löschen</Modal.Header>
                            <Modal.Content>
                                Sicher löschen?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeDeleteInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={this.openDeletePropanModal.bind(this, this.props.propan.id)}

                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                {this.edit ?
                    <Table.Cell>
                        <Modal centered={false} className={"modal-top"} open={this.state.open} size="small"
                               trigger={
                                   <Icon name='edit' color="green"
                                         onClick={() => {
                                             this.openEditPropanModal();
                                             this.setState({open: true, edit: true});
                                         }}/>
                               }>
                            <Modal.Header>{this.isEditModal ? "Bearbeiten" : "Hinzufügen"}</Modal.Header>
                            <Modal.Content>
                                <Form error={this.error}>
                                    <Form.Group widths='equal'>


                                        <Form.Field>
                                            <label>Datum</label>

                                            <DatePicker
                                                selected={this.editPropan.date}
                                                onChange={this.handleChange.bind(this)}
                                                dateFormat="dd.MM.yyyy"
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Menge [l]</label>
                                            <NumberFormat value={parseFloat(this.editPropan.amountliter)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('amountliter', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" l"/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Heizwert</label>
                                            {calorificvalue}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>kWh</label>
                                            {Math.round(this.editPropan.amountliter * calorificvalue * 100) / 100}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Kosten [€]</label>
                                            <NumberFormat value={parseFloat(this.editPropan.costs)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('costs', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" €"/>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Nachweis</label>
                                            <Form.Input value={this.editPropan.proof}
                                                        type='proof'
                                                        onChange={this.handleInputChange.bind(this, 'proof')}/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Bemerkung</label>
                                            <Form.Input value={this.editPropan.comment}
                                                        type='comment'
                                                        onChange={this.handleInputChange.bind(this, 'comment')}/>
                                        </Form.Field>

                                    </Form.Group>
                                    <Message
                                        error
                                        header='Fehler'
                                        content={this.errorMessage}
                                    />
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={() => this.checkInputValues()}
                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                <Table.Cell>
                    {new Date(this.props.propan.date * 1000).toLocaleDateString()}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.propan.amountliter.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.propan.calorificvalue)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.propan.amountkWh.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(this.props.propan.costs.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {this.props.propan.comment}
                </Table.Cell>
                <Table.Cell>
                    {this.props.propan.proof}
                </Table.Cell>
            </Table.Row>
        );
    }
}